import { render, staticRenderFns } from "./ConfigurationSectionHeader.vue?vue&type=template&id=574bbc1f&"
import script from "./ConfigurationSectionHeader.vue?vue&type=script&lang=js&"
export * from "./ConfigurationSectionHeader.vue?vue&type=script&lang=js&"
import style0 from "./ConfigurationSectionHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports